<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-aside :width="width" style="padding:5px 0 0 10px;">
                <el-tree ref="tree" :data="dataList_tree"
                         highlight-current
                         :props="treeConfig"
                         node-key="id"
                         default-expand-all
                         @node-click="nodeClick">
                      <span slot-scope="{node,data}" class="custom-tree-node">
                         <i class="el-icon-folder" style="font-size: 16px;line-height: 21px;color:#dbc431"></i>
                        <span :title="node.label" style="font-size: 16px;" class="em-tree-text">
                            {{ node.label }}
                        </span>
                      </span>
                </el-tree>
            </el-aside>
            <div class="Ydriver"></div>
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="110"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <editDialog v-if="showEditDialog"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @submitForm="submitForm">
        </editDialog>
    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import dataTree from "@/components/tools/tree/dataTree";
    import editDialog from "@/components/page/wzgl/dlgl/editDialog";

    export default {
        name: "dlgl",
        props: ['menuData'],
        components: {dataTree, tableGrid, editDialog, toolBar},
        data() {
            return {
                treeConfig: {
                    children: 'children',
                    label: 'name',
                },
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "关键字搜索",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                width: "350px",

                showEditDialog: false,
                dialogLoading: false,

                treeData: {
                    id:""
                },
                dataUrl:"/producttype/listZTree",
                childUrl:"/producttype/getChildProductType?parentId=",

                dataList_tree:[],
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {
                        column_name: "_px", column_comment: "序号", column_width: "70"
                    },
                    {
                        column_name: "idleTime", column_comment: "呆料期", column_width: "100"
                    },
                    {
                        column_name: "proName", column_comment: "物资名称", column_width: "200"
                    },
                    {
                        column_name: "typeName", column_comment: "物资类别", column_width: "150"
                    },
                    {
                        column_name: "proCode", column_comment: "物资编码", column_width: "200"
                    },
                    {
                        column_name: "units", column_comment: "计量单位", column_width: "100"
                    },
                    {
                        column_name: "specification", column_comment: "规格型号", column_width: "200"
                    },
                    {
                        column_name: "origin", column_comment: "产地"
                    },
                    {
                        column_name: "color", column_comment: "颜色"
                    },
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

            }
        },
        async mounted() {
            await this.getTypeTree();
            this.getListData();
        },
        methods: {
            async getTypeTree() {
                this.loading = true;
                let param = {
                    url:this.dataUrl,
                    param:{
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                const retData = data.data.jsonStr;
                if(retData){
                    this.dataList_tree = retData;
                }
                this.loading = false;
            },
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/productidle/list",
                    param: {
                        productTypeId: this.treeData.id,
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }

                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.varList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
                this.$refs.tableGrid.clearSelList();
            },

            closeDialog() {
                this.showEditDialog = false;
            },
            async submitForm(form) {
                this.formData = form;
                this.dialogLoading = true;
                let param = {
                    ...this.formData,
                }
                let data = await this.$sqlOpt.save.save(param, "/productidle/save");
                if (data.infoCode === '0') {
                    this.$refs.tableGrid.clearSelList();
                    this.$message.success("保存成功");
                    this.closeDialog();
                    await this.getListData();
                }
                this.dialogLoading = false;
            },
            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
                let selList = this.$refs.tableGrid.getSelList();
                if (type === "add") {
                    this.showEditDialog = true;
                }
                if (type === "edit" || type === "delete" || type === "cancel") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }
                    if (type === "edit") {
                        this.showEditDialog = true;
                    }
                    if (type === "delete" || type === "cancel") {
                        let param = {
                            url: "/productidle/delete",
                            param: {
                                proIdleId: this.formData.proIdleId,
                            }
                        }
                        this.$sqlOpt.del.del(param, this, this.refresh);
                    }
                }
            },
            refresh() {
                this.getListData();
                this.refreshTree();
            },
            tableOpt() {
            },
            //点击左边表格
            selTree(data) {
                this.treeData = data;
                this.search();
            },
            async getChildData(id) {
                this.loading = true;
                let param = {
                    url:this.childUrl+id,
                    param:{
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                return data;
            },
            async handleNodeClick(data, node) {
                const res = await this.getChildData(data.id);
                this.$nextTick(() => {   //划重点了  $nextTick 不懂得上网查一下
                    this.$refs["tree"].updateKeyChildren(data.id, res.data.result);
                });
            },
            //点击左边表格
            nodeClick(data) {
                this.treeData = data;
                this.search();
                this.handleNodeClick(data);
            },
            //刷新左边表格
            refreshTree(key) {
                this.$refs.dataTree.refreshTree(key);
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
